import type { ToolTestResult } from '../../lib/api';
import { ToolTestErrorCard } from './ToolTestErrorCard';
import { ToolTestResponseCard } from './ToolTestResponseCard';

/** Renders one completed run: the response, or an engine-error card. */
export const ToolTestRunView = ({ result }: { result: ToolTestResult }) =>
  'error' in result ? <ToolTestErrorCard error={result} /> : <ToolTestResponseCard result={result} />;
